export default function useModalProvider(vm) {
  const $modalConfirm = vm.$refs.modalConfirm

  const productNotSynced = data => {
    $modalConfirm.show({
      title: 'Produk Belum di Mapping',
      description: 'Transaksi tidak bisa diproses karena ada produk yang belum dimapping. Yuk mapping produknya sekarang!',
      confirmLabel: 'Mapping Produk',
      onConfirm: () => {
        vm.$refs.modalConfirm.hide()
      },
      status: 'WARNING',
    })
  }

  const transactionSuccess = () => {
    $modalConfirm.show({
      title: 'Transaksi Berhasil',
      description: 'Pesanan telah berhasil diproses dan telah diteruskan ke gudang. Silahkan pantau status pesanan.',
      confirmLabel: 'Selesai',
      onConfirm: () => {
        vm.$refs.modalConfirm.hide()
      },
      status: 'SUCCESS',
    })
  }

  const fundNotEnough = () => {
    $modalConfirm.show({
      title: 'Saldo Tidak Cukup',
      description: 'Yah, saldo Kompay kamu tidak cukup untuk melakukan transaksi. Yuk TopUp saldo kamu sekarang!',
      confirmLabel: 'Top-Up Saldo',
      onConfirm: () => {
        vm.$router.push({ name: 'saldo', params: { topup: true } })
      },
      status: 'WARNING',
    })
  }

  const stockNotEnough = (productNames = 'yang kamu pilih') => {
    $modalConfirm.show({
      title: 'Stok Barang Tidak Cukup',
      description: `Yah, Stok produk ${productNames} tidak cukup untuk melakukan transaksi nih. Yuk tambah stok!`,
      confirmLabel: 'Tambah Stok Produk',
      onConfirm: () => {
        vm.$router.push({ name: 'ajukan-inbound' })
      },
      status: 'WARNING',
    })
  }

  const notDefinedError = () => {
    $modalConfirm.show({
      title: 'Terjadi Kesalahan',
      description: 'Terjadi kesalahan saat memproses transaksi. Silahkan coba lagi.',
      confirmLabel: 'Selesai',
      onConfirm: () => {
        vm.$refs.modalConfirm.hide()
      },
      status: 'WARNING',
    })
  }

  return {
    productNotSynced,
    transactionSuccess,
    fundNotEnough,
    stockNotEnough,
    notDefinedError,
  }
}
